import { render, staticRenderFns } from "./CommonUidTokenLoginPopup.vue?vue&type=template&id=0be4e437&scoped=true&"
import script from "./CommonUidTokenLoginPopup.vue?vue&type=script&lang=js&"
export * from "./CommonUidTokenLoginPopup.vue?vue&type=script&lang=js&"
import style0 from "./CommonUidTokenLoginPopup.vue?vue&type=style&index=0&id=0be4e437&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be4e437",
  null
  
)

export default component.exports